import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosClient from 'api/axiosClient';
import { SETTING_IMAGE_URL } from 'utils/constants';

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState({
        primaryColor: '#0063A3',
        logoUrl: 'https://lh3.googleusercontent.com/d/1E0fWyxr2lhpkFe95kWRiD3mfqCXomqMf',
        logoMobileUrl: 'https://lh3.googleusercontent.com/d/1E0fWyxr2lhpkFe95kWRiD3mfqCXomqMf',
        faviconUrl: 'https://lh3.googleusercontent.com/d/1DVdc8g9dhD3mNFAbRGiRtB3-T2-u34lk'
    });

    useEffect(() => {
        let isMounted = true;
        const pathSplit = window.location.pathname.split('/');
        const lang = pathSplit[1] === 'vi' ? 'vi' : 'en';

        const fetchConfig = async () => {
            try {
                const response = await axiosClient.get(`/settingall`);
                const data = response.data;

                if (data && isMounted) {
                    const newConfig = {
                        primaryColor: data.color ? (data.color.startsWith('#') ? data.color : `#${data.color}`) : '#0063A3',
                        logoUrl: lang === 'vi'
                            ? `${SETTING_IMAGE_URL}/${data.logoweb_vi}`
                            : `${SETTING_IMAGE_URL}/${data.logoweb}`,
                        logoMobileUrl: lang === 'vi'
                            ? `${SETTING_IMAGE_URL}/${data.logomobile_vi}`
                            : `${SETTING_IMAGE_URL}/${data.logomobile}`,
                        faviconUrl: `${SETTING_IMAGE_URL}/${data.icon}`
                    };

                    setConfig(newConfig);

                    // Inject primary color CSS variable
                    if (newConfig.primaryColor) {
                        document.documentElement.style.setProperty('--primary-color', newConfig.primaryColor);
                    }

                    // Inject Favicon
                    if (newConfig.faviconUrl) {
                        let link = document.querySelector("link[rel~='icon']");
                        if (!link) {
                            link = document.createElement('link');
                            link.rel = 'icon';
                            document.head.appendChild(link);
                        }
                        link.href = newConfig.faviconUrl;
                    }
                }
            } catch (error) {
                console.error("Error fetching web configuration:", error);
            }
        };

        fetchConfig();

        return () => {
            isMounted = false;
        };
    }, [window.location.pathname]);

    return (
        <ConfigContext.Provider value={{ config }}>
            {children}
        </ConfigContext.Provider>
    );
};

export const useConfig = () => useContext(ConfigContext);
